import * as React from "react";

const SevenElevenIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={32} height={20} rx={6} fill="#008061" />
    <g transform="translate(-6.57, -4.08) scale(0.44)">
      <path fill="#fff" fillRule="evenodd" d="M80.25,25.97l.29-.03.3.03.47.07.27.07.25.11.19.12.15.12.25.29.19.34.15.4.1.44v10.06h-3.39v-8.35l-.12-.29-.25-.22-.27-.15-.31-.04-.27.04-.32.19-.18.23-.16.32v8.27h-3.4v-11.73h3.4v1.14l.44-.37.27-.25.19-.18.25-.14.29-.15.34-.15.4-.12.49-.07h0ZM44.71,26.26v9.13h2.43v2.6h-5.87v-11.73h3.44ZM59.52,26.26l1.3,7.48,1.44-7.48h2.66l-2.23,11.73h-5.09l-1.71-11.73h3.63ZM72.29,26.26v2.6h-2.82v2.14h2.82v2.25h-2.82v2.14h2.82v2.6h-6.24v-11.73h6.24ZM31.08,31.03v2.25h-3.99v-2.25h3.99ZM39.03,26.26v2.6h-2.88v2.14h2.88v2.25h-2.88v2.14h2.88v2.6h-6.26v-11.73h6.26ZM54.62,26.26v2.6h-2.87v2.14h2.87v2.25h-2.87v2.14h2.87v2.6h-6.28v-11.73h6.28,0ZM17.69,29.05h4l.9-1,.49-.47.62-.49.53-.37.67-.41h-7.22v2.74ZM26.46,26.21c-2.23.56-4.41,2.72-5.07,4.3-1.41,3.2-1.17,7.5-1.17,7.5,0,0,2.44-.02,3.47-.02-.04-3.04-.02-4.93.42-6.41.43-1.48,2.35-2.46,2.35-2.46v-2.93ZM83.83,36.69c0-.64.49-1.13,1.11-1.13s1.1.49,1.1,1.13-.49,1.14-1.1,1.14-1.11-.48-1.11-1.14h0ZM84.94,38.06c.74,0,1.37-.58,1.37-1.36s-.63-1.36-1.37-1.36-1.38.58-1.38,1.36.63,1.36,1.38,1.36ZM84.65,36.8h.27l.41.68h.27l-.45-.69c.23-.03.41-.15.41-.43,0-.31-.18-.45-.55-.45h-.6v1.57h.24v-.68h0ZM84.65,36.6v-.49h.32c.17,0,.34.04.34.23,0,.24-.18.26-.38.26h-.28Z"/>
    </g>
  </svg>
);

export default SevenElevenIcon;
